import { FacebookCustomEvent, FacebookPageViewEvent, FacebookSearchEvent } from './facebook';
import {
  FirebaseCustomEvent,
  FirebasePageViewEvent,
  FirebaseScreenViewEvent,
  FirebaseViewSearchResultsEvent,
} from './firebase';
import { isCordova } from '../util/mobile/deviceDetection';
import { hasNativeAnalytics } from './nativeFirebase';

export class LoggingAnalyticsHandler {
  trackEvent(url) {
    //console.log('Analytics page view:', url);
  }
}

const logPageView = (url, routeName, previousLocation) => {
  if (hasNativeAnalytics()) {
    // App streams report screens, not pages — screen_view is the native
    // counterpart of page_view (page_view stays web-only).
    FirebaseScreenViewEvent.withScreenName(routeName || url)
      .withPageLocation(url)
      .withPageReferer(previousLocation)
      .logEvent();
  } else {
    FirebasePageViewEvent.withPageLocation(url).withPageReferer(previousLocation).logEvent();
  }
};

export class GoogleTrackingEventHandler {
  trackEvent(url, store, routeName, { initialPageLoad = false } = {}) {
    const { previousLocation } = store.getState().routing;

    const urlObj = new URL(process.env.REACT_APP_CANONICAL_ROOT_URL + url);
    const { search } = urlObj;

    // The GA4 web SDK sends the landing page's page_view itself on init.
    if (!initialPageLoad) logPageView(url, routeName, previousLocation);
    if (routeName === 'SearchPage') {
      const searchParams = new URLSearchParams(search);
      const address = searchParams.get('address');
      searchParams.delete('address');
      let additionalKeys = [];
      for (const key of searchParams.keys()) {
        additionalKeys.push({ key, value: searchParams.get(key) });
      }
      FirebaseViewSearchResultsEvent.withSearchTerm(address)
        .withAdditionalKeys(additionalKeys)
        .logEvent();
    }

    const searchParams = new URLSearchParams(search);
    if (searchParams.has('event')) {
      const urlParamEvent = JSON.parse(window.atob(searchParams.get('event') || ''));
      FirebaseCustomEvent.withCustomName(urlParamEvent.name)
        .withParams(urlParamEvent.params)
        .logEvent();
    }
  }
}

// The href of the tracked location (the apps use a hash router). Relayed
// explicitly: the relay is awaited, and window.location may have moved on to
// the next page by the time it fires.
const toHref = (location) => {
  if (!location) return null;
  const { pathname, search = '', hash = '' } = location;
  const path = `${pathname}${search}${hash}`;
  if (isCordova()) return `${window.location.href.split('#')[0]}#${path}`;
  return `${window.location.origin}${path}`;
};

export class FacebookTrackingEventHandler {
  trackEvent(url, store, routeName, { location } = {}) {
    const urlObj = new URL(process.env.REACT_APP_CANONICAL_ROOT_URL + url);
    const { search } = urlObj;
    const userUUID = store.getState().user.currentUser?.id?.uuid;
    const sourceUrl = toHref(location);

    FacebookPageViewEvent.withCurrentUserUUID(userUUID).withSourceUrl(sourceUrl).logEvent();

    if (routeName === 'SearchPage') {
      FacebookSearchEvent.withCurrentUserUUID(userUUID)
        .withSourceUrl(sourceUrl)
        .withSearchString(search)
        .logEvent();
    }

    const searchParams = new URLSearchParams(search);
    if (searchParams.has('event')) {
      const urlParamEvent = JSON.parse(window.atob(searchParams.get('event') || ''));
      FacebookCustomEvent.withCurrentUserUUID(userUUID)
        .withSourceUrl(sourceUrl)
        .withCustomName(urlParamEvent.name)
        .withParams(urlParamEvent.params)
        .logEvent();
    }
  }
}
